import { LuIcon } from "@overmap-ai/blocks"
import { selectProcedureStepById } from "@overmap-ai/core"
import { cx } from "class-variance-authority"
import { type ComponentPropsWithRef, memo } from "react"
import { twMerge } from "tailwind-merge"

import { modelIconMapping } from "../../mappings/icons"
import { useAppSelector } from "../../store"
import { DEFAULT_MAX_ICONS } from "./constants"
import type { IconsProps } from "./typings"

interface ProcedureStepIconProps extends ComponentPropsWithRef<"svg"> {
	procedureStepId: string
}

export const ProcedureStepIcon = memo<ProcedureStepIconProps>((props) => {
	const { ref, className, procedureStepId, ...rest } = props

	const procedureStep = useAppSelector(selectProcedureStepById(procedureStepId))

	return (
		<LuIcon
			className={twMerge(cx(className, "shrink-0"))}
			ref={ref}
			icon={modelIconMapping.stage}
			color={procedureStep?.color}
			fill={procedureStep?.color}
			{...rest}
		/>
	)
})
ProcedureStepIcon.displayName = "ProcedureStepIcon"

interface ProcedureStepIconsProps extends IconsProps {
	procedureStepIds: string[]
}

export const ProcedureStepIcons = memo<ProcedureStepIconsProps>((props) => {
	const { ref, className, procedureStepIds, max = DEFAULT_MAX_ICONS, ...rest } = props

	return (
		<span ref={ref} className={cx("flex -space-x-2", className)} {...rest}>
			{procedureStepIds.slice(0, max ?? procedureStepIds.length).map((procedureStepId) => (
				<ProcedureStepIcon procedureStepId={procedureStepId} key={procedureStepId} />
			))}
		</span>
	)
})
ProcedureStepIcons.displayName = "ProcedureStepIcons"
